interface ConverterProps {
  [k: string]: string
}

const parseConvert: ConverterProps = {
  AS_WEAR_AND_TEAR_OWNER_SENTIMENT: 'AS - Wear & Tear / Owner Sentiment',
  SelfInvoicingMT: 'Maintenance Tech',
  SelfInvoicingHK: 'Self-Invoicing - Housekeeping',
  SelfInvoicingInspection: 'Self-Invoicing - Inspection',
  VendorInvoice: 'Invoice',
  OrderDotCo: 'Order.co',
  CreditCard: 'Credit Card',
  ExistingInventory: 'Existing Inventory',
  RampCard: 'Ramp Card',
  EmailInvoice: 'Email Invoice',
  'FF&E Replacement': 'FF&E Replacement',
  FIELD_OPS: 'Field Operations',
  AVANTSTAY: 'AvantStay',
  AVANT_STAY: 'AvantStay',
  'OS&E': 'OS&E',
  'FF&E': 'FF&E',
  AUTO_APPROVED: 'Auto-Approved',
  'AS Termination': 'AS Termination',
  IOT: 'IOT',
  'NOT-ISGI': 'Not-ISGI',
  ISGI: 'ISGI',
  ESCALATION: 'Owner Escalation',
  'CX Escalation': 'CX Escalation',
  QBR_ENGAGEMENT: 'NPS Engagement',
  VIOLATING_CC_AND_RS: 'Violating CC&Rs',
  OS_AND_E: 'OS&E',
  BACK_TO_BACK: 'Back to Back',
  BBQ: 'BBQ',
  TV: 'TV',
  EV_CHARGING: 'EV Charging',
  WASHER_AND_DRYER: 'Washer and Dryer',
  PULL_OUT_LINEN: 'Pull-Out Linen',
  PACK_N_PLAY_TRAVEL_CRIB: 'Pack n Play Travel Crib',
}

export const parseLabel = (label?: string) => {
  if (!label) return '—'
  if (Object.keys(parseConvert).includes(label)) return parseConvert?.[label] ?? label

  return String(label)
    .replaceAll('_', ' ')
    .toLowerCase()
    .split(/([^\w]+)/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('')
}
